import { z } from "zod";

export const ZodServerSetString = z
	.string()
	.transform((val) => {
		if (!val) return null;
		return val;
	})
	.or(z.null())
	.default(null);
